"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Form = void 0;
var react_1 = __importDefault(require("react"));
var storybook_1 = require("@eyecons/storybook");
var prop_types_1 = __importDefault(require("prop-types"));
var Form = function (_a) {
    var plan = _a.plan, user = _a.user, channel = _a.channel, status = _a.status;
    return react_1.default.createElement("div", { className: 'storybook-subscription-form' },
        react_1.default.createElement("div", { className: 'storybook-subscription-thumbnail', style: { backgroundImage: "url(" + plan.thumbnail + ")" } }),
        react_1.default.createElement("div", { className: 'storybook-subscriptions-form-container' },
            react_1.default.createElement(storybook_1.Forms.Form, null,
                react_1.default.createElement("div", { className: 'storybook-plans-card-heading' },
                    react_1.default.createElement(storybook_1.Texts.Heading, { className: 'mb-xs font-bold' }, plan.label)),
                react_1.default.createElement(storybook_1.Forms.Field, null,
                    react_1.default.createElement(storybook_1.Texts.Primary, null, plan.description)),
                react_1.default.createElement(storybook_1.Forms.Field, null,
                    react_1.default.createElement("ul", null,
                        channel.livestreams_count > 0 && react_1.default.createElement("li", null,
                            react_1.default.createElement(storybook_1.Texts.Primary, null,
                                react_1.default.createElement("span", { className: 'text-green-300' }, "\u2713"),
                                " ",
                                channel.livestreams_count,
                                " live kanaal")),
                        react_1.default.createElement("li", null,
                            react_1.default.createElement(storybook_1.Texts.Primary, null,
                                react_1.default.createElement("span", { className: 'text-green-300' }, "\u2713"),
                                " Exclusieve clubcontent")),
                        react_1.default.createElement("li", null,
                            react_1.default.createElement(storybook_1.Texts.Primary, null,
                                react_1.default.createElement("span", { className: 'text-green-300' }, "\u2713"),
                                " Eyecons exclusives")))),
                react_1.default.createElement(storybook_1.Subscriptions.FormButtons, { owner_id: user.id, plan: plan, status: status }))));
};
exports.Form = Form;
exports.Form.propTypes = {
    /**
     * Current channel session
     */
    plan: prop_types_1.default.shape({
        id: prop_types_1.default.number.isRequired,
        month: prop_types_1.default.number.isRequired,
        year: prop_types_1.default.number.isRequired,
        label: prop_types_1.default.string.isRequired,
        description: prop_types_1.default.string.isRequired,
        thumbnail: prop_types_1.default.string.isRequired,
    }).isRequired,
    /**
     * Current user session
     */
    user: prop_types_1.default.shape({
        id: prop_types_1.default.number.isRequired,
    }).isRequired,
    status: prop_types_1.default.string
};
